export function hasMethod<K extends PropertyKey>(
  value: unknown,
  method: K,
): value is Record<K, (...args: any[]) => any> {
  return (
    value !== null
    && typeof value === 'object'
    && method in value
    && typeof (value as Record<K, unknown>)[method] === 'function'
  );
}
